<template>
  <div>
    <div class="mb-3">
      <span v-for="(participant, index) in visit.participants" :key="index" class="mr-1">
        <badge :type="getType(participant, 'color')">
          <div>{{ participant.participable.name }}</div>
          <small>({{ getType(participant, 'role') }})</small>
        </badge>
      </span>
    </div>

    <div v-if="visit.visitDate" class="d-inline-block w-50">
      <p class="h5">Fecha de visita</p>
      <p>{{ visit.visitDate | date('DD/MM/YYYY HH:mm') }}</p>
    </div>

    <div v-else>
      <p class="h5">Fecha programada</p>
      <p>{{ visit.appointmentDate | date('DD/MM/YYYY HH:mm') }}</p>
    </div>

    <div v-if="visit.visitNextDate" class="d-inline-block w-50">
      <p class="h5">Fecha de próxima visita</p>
      <p>{{ visit.visitNextDate | date('DD/MM/YYYY HH:mm') }}</p>
    </div>

    <div>
      <p class="h5">Detalles</p>
      <comment :text="visit.details" :user-name="visit.user.name" :user-role="visit.user.role.label" />
    </div>
    <div v-if="$can('private', 'visits') && visit">
      <base-switch
        class="switch-container float-right mt-2"
        type="danger"
        :value="visit.share"
        off-text="Visita Privada"
        on-text="Visita Pública"
        @input="changeVisitPrivacy"
      ></base-switch>
    </div>
  </div>
</template>

<script>
import Comment from '@/components/Comment';
import swal from 'sweetalert2';

export default {
  components: {
    Comment,
  },

  props: {
    visit: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      types: {
        sellers: { color: 'primary', role: 'Asesor Técnico' },
        distributors: { color: 'success', role: 'Distribuidor' },
        producers: { color: 'info', role: 'Productor' },
      },
    };
  },

  methods: {
    getType(p, prop) {
      return this.types[p.participableType][prop];
    },

    changeVisitPrivacy() {
      this.$services
        .resource('visits')
        .update(this.visit.id, { share: !this.visit.share })
        .then(() =>
          swal({
            title: 'Listo!',
            text: 'Fue cambiada la privacidad de la visita.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          })
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-container {
  min-width: 120px;
}

::v-deep .custom-toggle input:checked + .custom-toggle-slider:before {
  transform: translateX(96px) !important;
}

::v-deep .custom-toggle-slider {
  border: 1px solid #2d2d2d;
  &:after {
    font-size: 14px;
    color: #2d2d2d;
  }
  &:before {
    background-color: #2d2d2d;
  }
}
</style>
